import React from "react";
import { TextFieldStyle } from "./text-input-field.style";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  TextField,
  Skeleton,
  InputAdornment,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { TextInputFieldPropTypes } from "./text-input-field-types";
import InfoIcon from "../../info-icon/info-icon";

const TextInputField = ({
  name,
  label,
  value,
  error,
  disabled,
  isLoading,
  multiline,
  rows = 1,
  inputType,
  className,
  fieldSize,
  maxRows = 1,
  tooltipData,
  placeholder,
  tooltipClass,
  tooltipPlacement,
  isRequired,
  onChange,
  onBlur,
  helperText = null,
  InputProps,
  autoFocus = false,
  maxLength = null,
  disablePointerEvents = true,
  onKeyDown,
  onKeyUp,
  focussed,
  sx,
  isTransparent = false,
  readOnly = false,
  description,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);
  return (
    <TextFieldStyle
      className={className}
      fieldSize={fieldSize}
      data-testid="text-field"
      inputType={inputType}
      multiline={multiline}
      isTransparent={isTransparent}
    >
      {isLoading ? (
        <Skeleton variant="rectangular" width={334} height={41} />
      ) : (
        <Tooltip
          title={tooltipData || ""}
          classes={{
            tooltip: tooltipClass || "tooltip-tile",
            arrow: "tooltip-arrow ",
          }}
          arrow
          placement={tooltipPlacement || "left"}
        >
          <div className="input-wrapper">
            {label && (
              <div className="label">
                <Typography variant="body1">
                  {label}
                  {isRequired && "*"}

                  {description && <InfoIcon message={description} />}
                </Typography>
              </div>
            )}
            <TextField
              sx={{ width: "100%", ...sx }}
              autoFocus={autoFocus}
              aria-label="input-field"
              value={value}
              id={name}
              readOnly={readOnly}
              type={showPassword ? "text" : inputType}
              onChange={onChange}
              onBlur={onBlur}
              error={!!error}
              multiline={multiline}
              rows={rows || 2}
              placeholder={placeholder}
              maxRows={maxRows}
              helperText={error?.message || helperText || null}
              disabled={disabled}
              autoComplete="off"
              inputProps={{
                maxLength: maxLength,
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                autoComplete: inputType === "password" ? "new-password" : "off",
              }}
              InputProps={{
                ...InputProps,
                endAdornment:
                  inputType === "password" ? (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        disableRipple
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ) : InputProps?.endAdornment ? (
                    InputProps.endAdornment
                  ) : (
                    <span />
                  ),
              }}
            />
          </div>
        </Tooltip>
      )}
    </TextFieldStyle>
  );
};

TextInputField.propTypes = TextInputFieldPropTypes;

export default TextInputField;
